module.exports = __webpack_public_path__ + "static/media/6.a343fd28.jpg";